// extracted by mini-css-extract-plugin
export default {"inputGroup":"InputGroup_inputGroup__fogQ2","formGroup":"InputGroup_formGroup__b3hFk"};